import { render } from "./Tutorial.vue?vue&type=template&id=4657c615&scoped=true&ts=true"
import script from "./Tutorial.vue?vue&type=script&lang=ts"
export * from "./Tutorial.vue?vue&type=script&lang=ts"

import "./Tutorial.vue?vue&type=style&index=0&id=4657c615&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4657c615"]])

export default __exports__